import { Component, Input } from '@angular/core';
import { JobContact } from '../../../../Jobbing/models/JobContact';
import { JobAddressSelection } from '../../../../Jobbing/models/JobAddressSelection';

@Component({
  selector: 'app-job-from-location-details-box',
  standalone: true,
  templateUrl: './job-from-location-details-box.component.html',
  styleUrl: './job-from-location-details-box.component.scss'
})
export class JobFromLocationDetailsBoxComponent {
  @Input()
  fromJobAddress?: JobAddressSelection;

  @Input()
  fromJobContact?: JobContact | null;
}
